(function () {
  window.addEventListener('DOMContentLoaded', () => {
      const newsletter_btns = document.querySelectorAll('.newsletter-field__submit button');
      const newsletter_close = document.querySelector('.js-newsletter-modal__close');
      const html = document.querySelector('html');
      const newsletter_popup = document.querySelector('.js-newsletter-modal');
      const subscribeButton = document.querySelector('.js-subscribe-button');
      const subscribeContent = document.querySelector('.js-news-letter-modal__subscribe');
      const newsLetterForm = document.querySelector('.js-newsletter-modal__form');
      const fieldButton = document.querySelector('.newsletter-field__button');
      const successCloseButton = document.querySelector('.js-button-success');
      const errorCloseButton = document.querySelector('.js-button-error');
      const successModal = document.querySelector('.js-newsletter-modal__success');
      const errorModal = document.querySelector('.js-newsletter-modal__error');
      const modalWrapper = document.querySelector('.js-newsletter-modal__group');
      const isLogin = html.dataset.login;
      const pageTemplate = html.dataset.template;
      let counter = parseInt(sessionStorage.getItem('page-counter'), 10);
      let lastScroll = 0;

      function displayPopup() {
        newsletter_popup.style.display = 'block';
        newsletter_popup.classList.remove('success');
        lastScroll = window.scrollY;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        setTimeout(() => {
            document.body.style.top = '-' + lastScroll + 'px';
        }, 0);
      }

      if (window.location.href.indexOf("#join-us") > -1) {
        displayPopup();
      }

      function getCookie(name) {
          let cookie = {};
          document.cookie.split(';').forEach(function (index) {
              let [key, value] = index.split('=');
              cookie[key.trim()] = value;
          })
          return cookie[name];
      }

      function navigationClicks() {
          Number.isNaN(counter) ? counter = 0 : counter;
          sessionStorage.setItem('page-counter', counter + 1);
      }

      console.log('pageTemplate', pageTemplate);

      if (getCookie("age_gate") == "off") {
          window.addEventListener('pageshow', function () {
              if (isLogin === 'true' || sessionStorage.getItem('newsletter-popup') === 'off') {
                  if (sessionStorage.getItem('page-counter')) {
                      sessionStorage.removeItem('page-counter')
                  }
                  sessionStorage.removeItem('page-counter');
              } else {
                  if (pageTemplate !== 'cart' && pageTemplate !== 'product' && pageTemplate !== 'collection') {
                      navigationClicks();
                  }
              }

              if (sessionStorage.getItem('page-counter') === '4' || sessionStorage.getItem('page-counter') === 4) {
                  newsletter_popup.style.display = 'block';
                  newsletter_popup.classList.remove('success');
                  lastScroll = window.scrollY;
                  document.body.style.overflow = 'hidden';
                  document.body.style.position = 'fixed';
                  subscribeContent.classList.remove('is-hidden');
                  newsLetterForm.classList.remove('is-shown');
                  sessionStorage.setItem('newsletter-popup', 'off');
                  sessionStorage.removeItem('page-counter')
              }
          });
      }

      fieldButton.addEventListener('click', function () {
          subscribeContent.classList.add('is-hidden');
          newsLetterForm.classList.add('is-shown');
      });

      if (newsletter_btns.length > 0) {
          newsletter_btns.forEach(button => {
              button.addEventListener('click', function (e) {
                  e.preventDefault();
                  displayPopup();
              });
          });
      }

      newsletter_close.addEventListener('click', function (e) {
          newsletter_popup.style.display = 'none';
          e.preventDefault();
          document.body.style.overflow = '';
          document.body.style.position = '';
          window.scrollTo(0, lastScroll * -1);
      });

      document.addEventListener('click', function (e) {
          let newsletter_wrap = e.target.classList.contains('js-newsletter-modal') ? e.target : e.target.closest('.js-newsletter-modal');
          if (newsletter_wrap) {
              e.stopPropagation();
          }
      });

      subscribeButton.addEventListener('click', function () {
          subscribeContent.classList.add('is-hidden');
          newsLetterForm.classList.add('is-shown');
          subscribeContent.classList.add('is-hidden');
      });

      successCloseButton.addEventListener('click', function (e) {
          newsletter_popup.style.display = 'none';
          e.preventDefault();
          document.body.style.overflow = '';
          document.body.style.position = '';
          window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
          successModal.classList.remove('is-show');
          modalWrapper.classList.remove('is-hidden');
      });

      errorCloseButton.addEventListener('click', function (e) {
          newsletter_popup.style.display = 'none';
          e.preventDefault();
          document.body.style.overflow = '';
          document.body.style.position = '';
          window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
          errorModal.classList.remove('is-show');
          modalWrapper.classList.remove('is-hidden');
      });

  });
})();